const initState = {};

const GeneralDropDownsReducer = (state = initState, action) => {
    switch (action.type) {
        case 'GeneralDropDowns': return action.payload;
        case 'ADD_PATIENT_TO_DROPDOWNS':
            return {
                ...state,
                DisCardActiveIds: {
                    ...state.DisCardActiveIds,
                    Patient: [...state.DisCardActiveIds.Patient, action.payload]
                }
            };
        default: return state;
    }
}
export default GeneralDropDownsReducer;